<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                    <div class="row breadcrumbs-top">
                    <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Dock In/Out Analysis </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">

                                <li class="breadcrumb-item"><a href="#">Reports</a>
                            </li>
                            
                            <li class="breadcrumb-item active"> Analysis
                            </li>
                            <li class="breadcrumb-item active">Dock In Out
                            </li>
                            
                            </ol>
                        </div>
                    </div>
                    </div>
                </div>
            
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <section>
                    <div class="card border-none mb-1">
                        <div class="card-header py-1 filter_card_searchbgst_dock filter_rotation_onlick ">
                            <div class="container-fluid" @click="toggleCollapse">
                                <div class="row row fc_my-05">
                                     <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex mr-1">
                                            <div class="avatar-content">
                                                <em data-feather='search' class="custom-class avatar-icon font-medium-3"></em>
                                            </div>
                                        </div>
                                        <h4 class="card-title d-inline-flex ml-1"> Search Dock In/Out Analysis </h4>
                                     </div>
                                     <span class="rotetions_view_arrow ml-auto mx-1"> 
                                        <em class="las la-angle-down"></em>
                                        </span>
                                   
                                </div>
                            </div>
                           
                        </div>
                        <div  v-if="isCollapsed" class="collapsed-div">
                            <div class="card-body pt-1">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">Vehicle No</label>
                                        <treeselect placeholder="Select Vehicle Number" v-model="search.vehicle_id" :options="search.vehicleNumberList"  />
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">From Date</label>
                                        <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100" ></date-picker>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">To Date</label>
                                        <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100" ></date-picker>
                                    </div>
                                    <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">Gate Type</label>
                                        <treeselect placeholder="Select Gate Type"  />
                                       
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                        <label class="form-label text-left w-100">Gate Type</label>
                                        <treeselect placeholder="Select Gate Type"  />
                                       
                                    </div> -->
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-8 text-right mb-1 all_buttons_style">
                                        <button type="submit" class="btn btn-relief-primary mt-2 mr-1" @click="getReports('report', search)">
                                            Search
                                        </button>
                                        <button type="submit" class="btn btn-relief-primary mt-2 mr-1" @click="resetFilters">
                                            clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </section>
                <div class="container">  
                    <div class="epg-tabs subcategory-tabs no-bg scroll-both">
                        <nav class="nav-tabs-wrapper main_divtabsview">
                            <ul class="tabs_masters_detailstabing_pills d-flex justify justify-content-end nav nav-pills ml-auto  nav-pill-primary ">
                                <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1" @click="activateReport">
                                    <a class="nav-link active" id="report_tab" data-toggle="tab" href="#report" aria-expanded="true" >Report
                                    </a>
                                </li>
                                <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1" @click="deActivateReport">
                                    <a class="nav-link" id="chart_tab" data-toggle="tab" href="#chart" aria-expanded="true" >Charts
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div> 
                </div>
                <section>
                     <div class="card">
                       
                        <div class=" col-lg-12 mt-0 px-0">
                            <div class="card text-center mb-1">
                                <div class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0">
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active" id="report" aria-labelledby="report_tab" aria-expanded="true">
                                            <div class="container px-0" >
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-hover table-striped table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left align-middle py-1" style="min-width: 120px;">Date</th>
                                                                <th class="text-left align-middle">Vehicle No.</th>
                                                                <!-- <th  class="text-left align-middle">Datewise trip count</th> -->
                                                                <th  class="text-left align-middle" style="min-width: 230px;">Route Details</th>

                                                                
                                                                <th  class="text-left align-middle">Superwiser Name</th>
                                                                <th  class="text-left align-middle">Dock Details</th>

                                                                <!-- <th  class="text-left align-middle">Dock In Time</th>
                                                                <th  class="text-left align-middle">Seal Break Time</th>
                                                                <th  class="text-left align-middle">Dock Out Time</th>
                                                                <th  class="text-left align-middle">Dock Duration</th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <vue-element-loading :active="isReportDataLoading" />
                                                            <template v-for="(data,index) in report.list"  >
                                                                <tr>
                                                                    <td data-column="Date" class="text-left">{{data.Date}}</td>
                                                                    <td data-column="Vehicle No." class="text-left">{{data.vehicle_number_plate}}</td>
                                                                    <!-- <td data-column="Datewise entry count" class="text-left">{{data.count}}</td> -->
                                                                     
                                                                    <td data-column="Route Details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Route No : </span>
                                                                            <span  class="text-center statuswisecenterview">{{formatValue(data.route_number)}}</span>
                                                                            
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Route Path : </span>
                                                                            
                                                                            <span  class="text-center statuswisecenterview">{{formatValue(data.route_path)}}</span>
                                                                            
                                                                        </div>
                                                                    </td>

                                                                    <td data-column="Route Path" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    
                                                                    <td data-column="Route Details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text">Dock In Time : </span>
                                                                            <span  class="text-center statuswisecenterview">{{formatTimeStampToMonth(data.entry_time)}}</span>
                                                                            
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Seal Break Time : </span>
                                                                            
                                                                            <span  class="text-center statuswisecenterview">{{data.seal_breaked_at ? formatTimeStampToMonth(data.seal_breaked_at) : "No Seal"}}</span>
                                                                            
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Dock Out Time : </span>
                                                                            
                                                                            <span  class="text-center statuswisecenterview">{{formatTimeStampToMonth(data.exit_time)}}</span>
                                                                            
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Dock Duration : </span>
                                                                            
                                                                            <span  class="text-center statuswisecenterview">{{convertMinutesToTime(data.entry_time, data.exit_time)}}</span>
                                                                            
                                                                        </div>
                                                                    </td>
                                                                    
                                                                    <!-- <td data-column="Dock In Time" class="text-left">{{formatTimeStampToMonth(data.entry_time)}}</td>
                                                                    <td data-column="Seal Break Time" class="text-left">{{data.seal_breaked_at ? formatTimeStampToMonth(data.seal_breaked_at) : "No Seal"}}</td>
                                                                    <td data-column="Dock Out Time" class="text-left">{{formatTimeStampToMonth(data.exit_time)}}</td>
                                                                    <td data-column="Duration" class="text-left">{{convertMinutesToTime(data.entry_time, data.exit_time)}}</td> -->
                                                                </tr>
                                                            </template>
                                                            <template v-if="!report.list.length">
                                                              <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="report.page" :records="report.totalcount" :per-page="report.pagelimit" @paginate="(e) => handlePageChange(e, 'report')"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel" class="tab-pane" id="chart" aria-labelledby="chart_tab" aria-expanded="false">
                                            <BarChart :chartData="chartData" />
                                            <hr />
                                            <LineChart :chartData="allocationLineChartData" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                     </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../../constants.js"
import { read, utils } from "xlsx";
// import schema from "../utils/schema";
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"
import BarChart from "./Charts/BarChart.vue"
import LineChart from "./Charts/LineChart.vue"

export default({
    name:'DockInOutAnalysis',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        BarChart,
        LineChart,
    },
    data() {
        return {
            isLoading: false,
            isReportDataLoading: false,
            isReportActive: true,
            isCollapsed: false,
            reportData: [],
            search: {
                vehicleNumberList: [],
                vehicle_id: null,
                start_date: null,
                end_date: null,
            },
            chartData: {
                labels: [],
                datasets: [
                    {
                      label: 'Dock Entry',
                      borderWidth: 1,
                      backgroundColor: [
                        'rgba(153, 102, 255, 0.2)',
                      ],
                      borderColor: [
                        'rgba(153, 102, 255, 1)',
                      ],
                      pointBorderColor: '#2554FF',
                      data: []
                    },
                    {
                      label: 'Dock Exit',
                      borderWidth: 1,
                      backgroundColor: [
                        'rgba(255, 159, 64, 0.2)',
                      ],
                      borderColor: [
                        'rgba(255, 159, 64, 1)',
                      ],
                      pointBorderColor: '#2554FF',
                      data: []
                    }
                ]
            },
            allocationLineChartData: {
                labels: [],
                datasets: [
                  {
                    label: 'Dock Allocations',
                    data: [],
                    fill: false,
                    borderColor: '#f76707',
                    backgroundColor: '#ffd8a8',
                    borderWidth: 1
                  }
                ]
            },
            report: {
                url: "/reports?type=report2",
                list: [],
                totalcount: 0,
                pageCount: 0,
                page: 1,
                pagelimit: CONSTANT.LIMIT,
                currPageNum: 0,
                pageoffset: 1,
            },
        }  
    } ,
    mounted(){
        
        
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        this.getReports()
        this.getDataForAnalysis('report2')
        this.getDataForAnalysis('dockAllocations')
        this.getVehicleNumberList()
    },
    methods: {
        resetFilters() {
            this.search.vehicle_id = null
            this.report.currPageNum = 0
            this.report.page = 1
            this.report.pageoffset = 1
            this.getReports()
        },
        getVehicleNumberList() {
            this.searchNameMasterList('vehicle_registration_master', 'vehicle_number_plate', null, 'vehicle_id', 'vehicle_transaction_type')
                .then(result => {
                    console.log(result.data)
                  this.search.vehicleNumberList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
            },
        activateReport() {
            this.isReportActive = true
        },
        deActivateReport() {
            this.isReportActive = false
        },
        getReports(tab="report", search={}) {
            this.isReportDataLoading = true
            let payload = {
                page: this[tab].page,
                rows: this[tab].pagelimit,
                vehicle_id: search.vehicle_id,
                start_date: search.start_date,
                end_date: search.end_date,
            }
            this.makeRequest("POST", `/reports?type=report2`, payload)
                .then(result => {
                    this.isReportDataLoading = false
                    this[tab].list = result.data.data.rows
                    this[tab].totalcount = result.data.data.count
                    this[tab].pageCount = Math.ceil(result.data.data.count / this[tab].pagelimit)
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        getDataForAnalysis(type) {
            this.isReportDataLoading = true
            this.makeRequest("GET", `/reports/bar/data-analysis?type=${type}`)
                .then(result => {
                    this.isReportDataLoading = false
                    let responseData = result.data.data
                    if(type === "report2") {
                        this.chartData.labels = responseData.dock_entry_pass.map(d => d.day)
                        this.chartData.datasets[0].data = responseData.dock_entry_pass.map(d => d.count)
                        this.chartData.datasets[1].data = responseData.dock_exit_pass.map(d => d.count)
                    } else if(type === "dockAllocations") {
                        this.allocationLineChartData.labels = responseData.dock_vehicle_allocation.map(d => d.day)
                        this.allocationLineChartData.datasets[0].data = responseData.dock_vehicle_allocation.map(d => d.count)
                    }
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        handlePageChange(pageNum, tab) {
            this[tab].pageoffset=pageNum
            this[tab].currPageNum = pageNum - 1

            this.getReports(tab, this.search);
            setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(`#${tab}`).offset().top -70
                });
            }, 500);
        },
        
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
</style>